const drawLine = (
  context,
  keypoint1,
  keypoint2,
  { lineWidth = null, strokeStyle = null, lineCap = null } = {},
  factor = 1.0
) => {
  // console.log(`factor: ${factor}`);
  // console.log(context);
  context.beginPath();
  context.moveTo(keypoint1.x * factor, keypoint1.y * factor);
  context.lineTo(keypoint2.x * factor, keypoint2.y * factor);
  context.lineWidth = lineWidth ?? 2;
  context.strokeStyle = strokeStyle ?? "red";
  context.lineCap = lineCap ?? "round"; // "butt";
  context.stroke();
};

const cosDistance = (point_1, point_2) => {
  const dx = point_2.x - point_1.x;
  const dy = point_2.y - point_1.y;
  const squaredDistance = dx * dx + dy * dy;
  const _distance = Math.sqrt(squaredDistance);
  return _distance;
};

const drawLines = ({ poses, context, factor }) => {
  // console.log("poses");
  // console.log(poses);
  if (factor == null) {
    factor = 1.0;
  }
  const strokeStyle = "#ffffff"; // MARK: d4d4d4 (grey)
  const fillStyle = "#ffffff";
  const keypoints = poses[0].keypoints;
  const lineWidth = 96 * factor; // 48
  const dotWidth = lineWidth * 1.5; // 1.0
  // keypoints.forEach(({ x, y, score, name }) => {
  //   // Draw a dot on the canvas
  //   const dotRadius = 5;
  //   const dotColor = "red";
  //   context.fillStyle = dotColor;
  //   context.beginPath();
  //   context.arc(x, y, dotRadius, 0, 2 * Math.PI);
  //   context.fill();
  // });
  // drawLine(context, keypoints[0], keypoints[1]); // Nose to left eye
  // drawLine(context, keypoints[0], keypoints[2]); // Nose to right eye
  // drawLine(context, keypoints[1], keypoints[3]); // Left eye to left ear
  // drawLine(context, keypoints[2], keypoints[4]); // Right eye to right ear
  // drawLine(context, keypoints[5], keypoints[6]); // Left shoulder to right shoulder
  // drawLine(context, keypoints[5], keypoints[7]); // Left shoulder to left elbow
  // drawLine(context, keypoints[7], keypoints[9]); // Left elbow to left wrist
  // drawLine(context, keypoints[6], keypoints[8]); // Right shoulder to right elbow
  // drawLine(context, keypoints[8], keypoints[10]); // Right elbow to right wrist
  // drawLine(context, keypoints[11], keypoints[12]); // Left hip to right hip
  // drawLine(context, keypoints[11], keypoints[13]); // Left hip to left knee
  // drawLine(context, keypoints[13], keypoints[15]); // Left knee to left ankle
  // drawLine(context, keypoints[12], keypoints[14]); // Right hip to right knee
  // drawLine(context, keypoints[14], keypoints[16]); // Right knee to right ankle
  // MARK: Draw the Match Stick Person
  context.fillStyle = fillStyle;
  context.beginPath();
  context.arc(keypoints[0].x * factor, keypoints[0].y * factor, dotWidth, 0, 2 * Math.PI);
  context.fill();
  // MARK: Center Neck
  const centerNeck = {
    x: (keypoints[5].x + keypoints[6].x) / 2,
    y: (keypoints[5].y + keypoints[6].y) / 2,
  };
  context.fillStyle = fillStyle;
  context.beginPath();
  context.arc(centerNeck.x * factor, centerNeck.y * factor, lineWidth / 2, 0, 2 * Math.PI);
  context.fill();
  // MARK: Nose to center neck
  drawLine(
    context,
    keypoints[0],
    centerNeck,
    {
      lineWidth,
      strokeStyle,
    },
    factor
  );
  // MARK: Left shoulder to right shoulder
  drawLine(
    context,
    keypoints[5],
    keypoints[6],
    {
      lineWidth,
      strokeStyle,
    },
    factor
  );
  // MARK: Left shoulder to left elbow
  drawLine(
    context,
    keypoints[5],
    keypoints[7],
    {
      lineWidth,
      strokeStyle,
    },
    factor
  );
  // MARK: Left elbow to left wrist
  drawLine(
    context,
    keypoints[7],
    keypoints[9],
    {
      lineWidth,
      strokeStyle,
    },
    factor
  );
  // MARK: Right shoulder to right elbow
  drawLine(
    context,
    keypoints[6],
    keypoints[8],
    {
      lineWidth,
      strokeStyle,
    },
    factor
  );
  // MARK: Right elbow to right wrist
  drawLine(
    context,
    keypoints[8],
    keypoints[10],
    {
      lineWidth,
      strokeStyle,
    },
    factor
  );
  // MARK: Center Hip
  const centerHip = {
    x: (keypoints[11].x + keypoints[12].x) / 2,
    y: (keypoints[11].y + keypoints[12].y) / 2,
  };
  // MARK: Center Hip to center neck
  drawLine(
    context,
    centerHip,
    centerNeck,
    {
      lineWidth: lineWidth * 1.5,
      strokeStyle,
    },
    factor
  );
  // context.fillStyle = "blue";
  // context.beginPath();
  // context.arc(centerHip.x, centerHip.y, 48, 0, 2 * Math.PI);
  // context.fill();
  // // MARK: Center hip to nose
  // drawLine(context, centerHip, centerNeck, {
  //   lineWidth,
  //   strokeStyle: "blue",
  // });
  // // MARK: Center hip to left hip
  // drawLine(context, centerHip, keypoints[11], {
  //   lineWidth,
  //   strokeStyle: "blue",
  // });
  // // MARK: Left hip to left knee
  // drawLine(context, keypoints[11], keypoints[13], {
  //   lineWidth,
  //   strokeStyle: "blue",
  // });
  // // MARK: Left knee left ankle
  // drawLine(context, keypoints[13], keypoints[15], {
  //   lineWidth,
  //   strokeStyle: "blue",
  // });
  // // MARK: Center hip to right hip
  // drawLine(context, keypoints[11], keypoints[12], {
  //   lineWidth,
  //   strokeStyle: "blue",
  // });
  // // MARK: Right hip to right knee
  // drawLine(context, keypoints[12], keypoints[14], {
  //   lineWidth,
  //   strokeStyle: "blue",
  // });
  // // MARK: Right knee right ankle
  // drawLine(context, keypoints[14], keypoints[16], {
  //   lineWidth,
  //   strokeStyle: "blue",
  // });

  return {
    nose: keypoints[0],
    leftEye: keypoints[1],
    rightEye: keypoints[2],
    leftEar: keypoints[3],
    rightEar: keypoints[4],
    leftShoulder: keypoints[5],
    rightShoulder: keypoints[6],
    leftElbow: keypoints[7],
    rightElbow: keypoints[8],
    leftWrist: keypoints[9],
    rightWrist: keypoints[10],
    leftHip: keypoints[11],
    rightHip: keypoints[12],
    leftKnee: keypoints[13],
    rightKnee: keypoints[14],
    leftAnkle: keypoints[15],
    rightAnkle: keypoints[16],
    shoulderLength: cosDistance(keypoints[5], keypoints[6]),
  };
};

const flipHorizontally = ({ imageData, canvas, context }) => {
  const pixelData = imageData.data;
  // Flip the image horizontally
  for (let y = 0; y < canvas.height; y++) {
    for (let x = 0; x < canvas.width / 2; x++) {
      const startIdx = (y * canvas.width + x) * 4;
      const endIdx = (y * canvas.width + (canvas.width - x - 1)) * 4;
      // Swap the pixel values for each channel (R, G, B, A)
      for (let i = 0; i < 4; i++) {
        const temp = pixelData[startIdx + i];
        pixelData[startIdx + i] = pixelData[endIdx + i];
        pixelData[endIdx + i] = temp;
      }
    }
  }
  context.putImageData(imageData, 0, 0);
};

const getToleratedTimeframes = ({ videoCurrentTime, tolerateSecond, source }) => {
  let gestures = [];
  // const start = parseFloat(Math.max(videoCurrentTime - tolerateSecond, 0.0)).toFixed(1); // Start of the range
  // const end = parseFloat(videoCurrentTime + tolerateSecond).toFixed(1); // End of the range
  // console.log("start");
  // console.log(start);
  // console.log("end");
  // console.log(end);
  // Generate numbers from start to end (inclusive) with step of 0.1
  // for (let i = start; i <= end; i += 0.1) {
  //   console.log("i");
  //   console.log(i);
  //   try {
  //     const steppingVideoCurrentTime = parseFloat(i).toFixed(1);
  //     console.log("steppingVideoCurrentTime");
  //     console.log(steppingVideoCurrentTime);
  //     gestures.push(source[steppingVideoCurrentTime]);
  //   } catch (error) {}
  // }
  try {
    gestures.push(source[(parseFloat(videoCurrentTime) - 0.1).toFixed(1)]);
    gestures.push(source[parseFloat(videoCurrentTime).toFixed(1)]);
    gestures.push(source[(parseFloat(videoCurrentTime) + 0.1).toFixed(1)]);
  } catch (error) {}
  gestures = gestures.filter((item) => item !== undefined);
  return gestures;
};

const calculateBingo = ({ userGesture, correctGestures }) => {
  let score = 0;
  const cosDisThreshold = 0.5;
  // console.log("sss");
  // console.log(correctGestures);
  // TODO: correctGestures compare 1s posture, number of correctGestures pass by outer scope, e.g. 1s tolerance => return 10 correectGestures
  for (let i = 0; i <= correctGestures.length - 1; i++) {
    if (score >= 2) {
      break;
    }
    const correctGesture = correctGestures[i];
    // console.log("correctGesture");
    // console.log(correctGesture);
    const userConstant = cosDistance(userGesture.leftShoulder, userGesture.rightShoulder);
    const userNormalizedLeftWristY = Math.abs(userGesture.leftWrist.y - userGesture.leftShoulder.y) / userConstant;
    const userNormalizedLeftWristX = Math.abs(userGesture.leftWrist.x - userGesture.leftShoulder.x) / userConstant;
    const userNormalizedRightWristY = Math.abs(userGesture.rightWrist.y - userGesture.rightShoulder.y) / userConstant;
    const userNormalizedRightWristX = Math.abs(userGesture.rightWrist.x - userGesture.rightShoulder.x) / userConstant;

    const correctConstant = cosDistance(correctGesture.leftShoulder, correctGesture.rightShoulder);
    const correctNormalizedLeftWristY = Math.abs(correctGesture.leftWrist.y - correctGesture.leftShoulder.y) / correctConstant;
    const correctNormalizedLeftWristX = Math.abs(correctGesture.leftWrist.x - correctGesture.leftShoulder.x) / correctConstant;
    const correctNormalizedRightWristY =
      Math.abs(correctGesture.rightWrist.y - correctGesture.rightShoulder.y) / correctConstant;
    const correctNormalizedRightWristX =
      Math.abs(correctGesture.rightWrist.x - correctGesture.rightShoulder.x) / correctConstant;

    const bingoLeft =
      (Math.abs(correctNormalizedLeftWristY - userNormalizedLeftWristY) < cosDisThreshold) &
      (Math.abs(correctNormalizedLeftWristX - userNormalizedLeftWristX) < cosDisThreshold);
    const bingoRight =
      (Math.abs(correctNormalizedRightWristY - userNormalizedRightWristY) < cosDisThreshold) &
      (Math.abs(correctNormalizedRightWristX - userNormalizedRightWristX) < cosDisThreshold);
    const bingoNumber = bingoLeft + bingoRight;
    score = Math.max(bingoNumber, score);
  }
  return score;
};

const gestureDifferences = ({ correctGesture, userGesture, lazyThreshold, correctGestures }) => {
  lazyThreshold = lazyThreshold ?? 0.2;
  const correctScoreThreshold = 0.8;
  const userScoreThreshold = 0.5;

  const frameScore = calculateBingo({ correctGesture, userGesture, correctGestures });

  correctGesture = {
    ...correctGesture,
    leftWristRatio: {
      x: correctGesture.leftWrist.x / correctGesture.canvasSize.width, // TODO: should use [11] [12] length as base
      y: correctGesture.leftWrist.y / correctGesture.canvasSize.height,
    },
    rightWristRatio: {
      x: correctGesture.rightWrist.x / correctGesture.canvasSize.width,
      y: correctGesture.rightWrist.y / correctGesture.canvasSize.height,
    },
  };
  userGesture = {
    ...userGesture,
    leftWristRatio: {
      x: userGesture.leftWrist.x / userGesture.canvasSize.width,
      y: userGesture.leftWrist.y / userGesture.canvasSize.height,
    },
    rightWristRatio: {
      x: userGesture.rightWrist.x / userGesture.canvasSize.width,
      y: userGesture.rightWrist.y / userGesture.canvasSize.height,
    },
  };
  let leftWristDiff = -1;
  let rightWisttDiff = -1;
  let leftMissing = 0;
  let rightMissing = 0;
  let leftLazy = 0;
  let rightLazy = 0;

  if (userGesture.leftWrist.score < userScoreThreshold) {
    leftMissing = 1;
  }
  if (userGesture.rightWrist.score < userScoreThreshold) {
    rightMissing = 1;
  }
  if (userGesture.leftWrist.score >= userScoreThreshold && correctGesture.leftWrist.score >= correctScoreThreshold) {
    leftWristDiff = cosDistance(correctGesture.leftWristRatio, userGesture.leftWristRatio);
  }
  if (userGesture.rightWrist.score >= userScoreThreshold && correctGesture.rightWrist.score >= correctScoreThreshold) {
    rightWisttDiff = cosDistance(correctGesture.rightWristRatio, userGesture.rightWristRatio);
  }
  if (leftWristDiff > lazyThreshold) {
    // console.log("left");
    leftLazy = 1;
  }
  // console.log(leftWristDiff);
  if (rightWisttDiff > lazyThreshold) {
    // console.log("right");
    rightLazy = 1;
  }
  // console.log(rightWisttDiff);
  return {
    status: {
      leftMissing,
      leftLazy,
      rightMissing,
      rightLazy,
    },
    leftWristDiff, // MARK: 0 - 1
    rightWisttDiff, // MARK: 0 - 1
    frameScore,
  };
};

const getReminders = ({ leftMissing, leftLazy, rightMissing, rightLazy }) => {
  let reminders = [];
  const missingThreshold = 24 * 2;
  const lazyThreshold = 24 * 0.9;
  let left = "左";
  let right = "右";
  if (leftMissing >= missingThreshold) {
    const _messages = ["偵測不到您的左手，請向後踏一步。"];
    reminders = [...reminders, _messages[Math.floor(Math.random() * _messages.length)]];
  }
  if (rightMissing >= missingThreshold) {
    const _messages = ["偵測不到您的右手，請向後踏一步。"];
    reminders = [...reminders, _messages[Math.floor(Math.random() * _messages.length)]];
  }
  if (leftLazy >= lazyThreshold) {
    const _messages = ["嘗試多伸展一下您的左手。"];
    reminders = [...reminders, _messages[Math.floor(Math.random() * _messages.length)]];
  }
  if (rightLazy >= lazyThreshold) {
    const _messages = ["嘗試多伸展一下您的右手。"];
    reminders = [...reminders, _messages[Math.floor(Math.random() * _messages.length)]];
  }
  return reminders;
};

const accuracyToRank = (accuracy) => {
  let rank = "B";
  if (accuracy < 0.1) {
    rank = "C+";
  } else if (accuracy < 0.2) {
    rank = "B-";
  } else if (accuracy < 0.3) {
    rank = "B";
  } else if (accuracy < 0.4) {
    rank = "B+";
  } else if (accuracy < 0.5) {
    rank = "A-";
  } else if (accuracy < 0.6) {
    rank = "A";
  } else if (accuracy < 0.7) {
    rank = "A+";
  } else if (accuracy < 0.8) {
    rank = "S";
  } else if (accuracy < 0.9) {
    rank = "SS";
  } else if (accuracy < 1.0) {
    rank = "SSS";
  }
  return rank;
};

export {
  accuracyToRank,
  cosDistance,
  drawLine,
  drawLines,
  getReminders,
  flipHorizontally,
  gestureDifferences,
  getToleratedTimeframes,
};
